import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  class: "relative",
  ref: "cityDropdownContainer"
}
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = ["type", "id", "placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "max-h-40 overflow-y-auto border-t border-gray-600"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "py-1 px-3 text-gray-400"
}
const _hoisted_8 = {
  key: 0,
  class: "mt-1 text-xs text-red-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: "block text-sm font-medium text-gray-300 mb-1"
    }, _toDisplayString(_ctx.label), 9, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-full bg-gray-700 border border-gray-600 rounded-md overflow-hidden", { 'border-red-500': _ctx.error }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: _ctx.type,
            id: _ctx.id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localSearch) = $event)),
            placeholder: _ctx.placeholder,
            class: _normalizeClass(["w-full bg-gray-700 py-2 px-3 text-white placeholder-gray-400 focus:outline-none", _ctx.inputClass]),
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDropdown = true)),
            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
            autocomplete: "off",
            onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
          }, null, 42, _hoisted_4), [
            [_vModelDynamic, _ctx.localSearch]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "absolute right-0 top-0 h-full px-2 text-gray-400",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 9l-7 7-7-7"
              })
            ], -1)
          ]))
        ]),
        (_ctx.showDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCities, (city) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: city,
                  onClick: ($event: any) => (_ctx.selectCity(city)),
                  class: "py-1 px-3 hover:bg-gray-600 cursor-pointer text-white"
                }, _toDisplayString(city), 9, _hoisted_6))
              }), 128)),
              (_ctx.filteredCities.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Nema rezultata "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ], 512),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}